module.exports = __webpack_public_path__ + "static/media/head-dether.da11cba8.png";